/**
 * Sprint 24.5 — TemplateStatusBadge.
 *
 * The small LIVE / COMING SOON / DEV ONLY pill on first-party template cards.
 * Colours per the visual contract (Q17 + per-surface map): green / amber / teal
 * ramp 50→900. Status strings match the worker registry's template.status.
 */

import type { CSSProperties } from "react";
import type { FirstPartyTemplate } from "../../../../hooks/use-first-party-templates";

type TemplateStatus = FirstPartyTemplate["status"];

const VARIANTS: Record<TemplateStatus, { bg: string; color: string; label: string }> = {
  live: { bg: "#EAF3DE", color: "#173404", label: "LIVE" },
  "coming-soon": { bg: "#FAEEDA", color: "#412402", label: "COMING SOON" },
  "dev-only": { bg: "rgba(15, 110, 86, 0.1)", color: "#04342C", label: "DEV ONLY" },
};

export interface TemplateStatusBadgeProps {
  status: TemplateStatus;
}

export function TemplateStatusBadge({ status }: TemplateStatusBadgeProps) {
  const v = VARIANTS[status] ?? VARIANTS["coming-soon"];
  const style: CSSProperties = {
    fontSize: 9,
    padding: "2px 7px",
    borderRadius: 999,
    fontWeight: 500,
    letterSpacing: "0.3px",
    textTransform: "uppercase",
    background: v.bg,
    color: v.color,
    fontFamily: "var(--font-sans)",
    lineHeight: 1.4,
    flexShrink: 0,
    whiteSpace: "nowrap",
  };
  return <span style={style}>{v.label}</span>;
}
